import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { HlmDialogService } from '@spartan-ng/helm/dialog';
import { map } from 'rxjs';

import { ConfirmDialogComponent } from '../shared/components/dialog/confirm-dialog/confirm-dialog.component';
import { FormComponent } from '../shared/models/form-component';

export const canDeactivateGuard: CanDeactivateFn<FormComponent> = (component: FormComponent) => {
  const dialog = inject(HlmDialogService);

  if (component.form.dirty) {
    const dialogRef = dialog.open(ConfirmDialogComponent, {
      context: {
        titre: 'Attention',
        contenu: 'Vous avez des informations non sauvegardées dans ce formulaire. Êtes-vous sûr de vouloir quitter ?',
      },
    });

    return dialogRef.closed$.pipe(map((result) => !!result));
  }
  return true;
};
